import React, { useState } from "react"
import { Link } from "react-router-dom"
import { navbar } from "../data/data"

export default function Header() {
  const [links] = useState(navbar)
  // const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <header className="header absolute w-full flex items-center justify-between p-5 z-10 lg:fixed">
        <div>
          <Link
            to="/"
            className="font-bold tracking-widest uppercase text-2xl text-white"
          >
            Jumba
          </Link>
        </div>

        <nav>
          <ul className="lg:flex lg:items-center lg:justify-center">
            {links.map(({ id, title, url }) => (
              <li key={id}>
                <Link
                  to={url}
                  className="text-slate-50 text-sm lg:mr-3 hover:bg-slate-500 transition-all duration-300 py-1 px-3 rounded-lg opacity-75 hover:opacity-100"
                >
                  {title}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </header>
    </>
  )
}
